var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFilterTypeAny(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    fill: "none",
    viewBox: "0 0 14 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#323657",
    d: "M8.182 4.688 3.282 9.5a.437.437 0 0 1-.614 0l-2.1-2.062a.437.437 0 1 1 .614-.624l1.793 1.76 4.594-4.51a.438.438 0 0 1 .613.624m5.255-.62a.437.437 0 0 0-.619-.005L8.225 8.575l-1.03-1.012a.438.438 0 0 0-.613.625L7.918 9.5a.437.437 0 0 0 .613 0l4.9-4.812a.44.44 0 0 0 .006-.62"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterTypeAny);
export default __webpack_public_path__ + "static/media/filter-type-any.2699cd07ce061b3da9a74f63ee9787a1.svg";
export { ForwardRef as ReactComponent };